import { css } from "@emotion/react";
import styled from "@emotion/styled";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider, { CustomArrowProps } from "react-slick";
import { PropsWithChildren } from "react";
import ChevronRight from "../../../../../img/chevron_right_thin.svg?react";
import ChevronLeft from "../../../../../img/chevron_left_thin.svg?react";
import { Button } from "components/general/Button/Button";
import { TABLET_WIDTH } from "hooks/useDeviceType";

interface CarouselProps {
  style?: React.CSSProperties;
}

export const Carousel = ({ children, style }: PropsWithChildren<CarouselProps>) => {
  return (
    <Container style={style}>
      <Slider
        variableWidth={true}
        nextArrow={<NextArrow />}
        prevArrow={<PrevArrow />}
        infinite={false}
      >
        {children}
      </Slider>
    </Container>
  );
};

// Sub-components

export const CAROUSEL_MARGIN_LEFT_PCT = 72;
export const CAROUSEL_FLEX_CONTAINER_GAP = 20;

const Container = styled.div`
  padding-top: 40px;
  width: 100%;
  .slick-slider {
    margin-left: ${CAROUSEL_MARGIN_LEFT_PCT}px;
    width: 100%;

    .slick-arrow::before {
      display: none;
    }

    .slick-list {
      padding: 0 !important;
      overflow: visible;

      .slick-track {
        display: flex;
        gap: ${CAROUSEL_FLEX_CONTAINER_GAP}px;
      }
    }
  }
`;

const PrevArrow = ({ className, onClick }: CustomArrowProps) => {
  return (
    <Button
      isDisabled={className?.includes("slick-disabled")}
      buttonType="secondary"
      buttonCss={css`
        position: absolute;
        top: -88px;
        right: calc(3% + 90px + 72px);
        padding: 16px;

        @media (max-width: ${TABLET_WIDTH - 400}px) {
          right: calc(50px + 72px);
        }
      `}
      onClick={onClick}
    >
      <ChevronLeft width={24} height={24} />
    </Button>
  );
};

const NextArrow = ({ className, onClick }: CustomArrowProps) => (
  <Button
    isDisabled={className?.includes("slick-disabled")}
    buttonType="secondary"
    buttonCss={css`
      position: absolute;
      top: -88px;
      right: calc(3% + 90px);
      padding: 16px;

      @media (max-width: ${TABLET_WIDTH - 400}px) {
        right: 50px;
      }
    `}
    onClick={onClick}
  >
    <ChevronRight width={24} height={24} />
  </Button>
);
